var items = {
  "block.minecraft.air": "luft",
  "block.minecraft.stone": "steinur",
  "block.minecraft.granite": "granitt",
  "block.minecraft.polished_granite": "pussað granitt",
  "block.minecraft.diorite": "dioritt",
  "block.minecraft.polished_diorite": "pussað dioritt",
  "block.minecraft.andesite": "andesitt",
  "block.minecraft.polished_andesite": "pussað andesitt",
  "block.minecraft.grass_block": "graskubbi",
  "block.minecraft.dirt": "mold",
  "block.minecraft.coarse_dirt": "grov mold",
  "block.minecraft.podzol": "rakjørð",
  "block.minecraft.crimson_nylium": "roðanoppavevnaður",
  "block.minecraft.warped_nylium": "tryglunoppavevnaður",
  "block.minecraft.cobblestone": "brúgvarsteinur",
  "block.minecraft.oak_planks": "eikiplankar",
  "block.minecraft.spruce_planks": "grannplankar",
  "block.minecraft.birch_planks": "bjarkarplankar",
  "block.minecraft.jungle_planks": "frumskógarplankar",
  "block.minecraft.acacia_planks": "akasiuplankar",
  "block.minecraft.dark_oak_planks": "myrkir eikiplankar",
  "block.minecraft.crimson_planks": "roðaviður",
  "block.minecraft.warped_planks": "trygluviður",
  "block.minecraft.oak_sapling": "ungt eikitræ",
  "block.minecraft.spruce_sapling": "grannspíri",
  "block.minecraft.birch_sapling": "bjarkarspíri",
  "block.minecraft.jungle_sapling": "frúmskógarspíri",
  "block.minecraft.acacia_sapling": "ungt akasiutræ",
  "block.minecraft.dark_oak_sapling": "ungt, myrkt eikitræ",
  "block.minecraft.bedrock": "hella",
  "block.minecraft.sand": "sandur",
  "block.minecraft.red_sand": "reyðsendi",
  "block.minecraft.gravel": "eyrur",
  "block.minecraft.gold_ore": "gullmálmur",
  "block.minecraft.iron_ore": "jarnmálmur",
  "block.minecraft.coal_ore": "kolamálmur",
  "block.minecraft.nether_gold_ore": "nethergullmálmur",
  "block.minecraft.oak_log": "eikistokkur",
  "block.minecraft.spruce_log": "grannstokkur",
  "block.minecraft.birch_log": "bjarkarstokkur",
  "block.minecraft.jungle_log": "frumskógarstokkur",
  "block.minecraft.acacia_log": "akasiubulur",
  "block.minecraft.dark_oak_log": "myrkur eikistokkur",
  "block.minecraft.crimson_stem": "roðastelkur",
  "block.minecraft.warped_stem": "tryglustelkur",
  "block.minecraft.stripped_oak_log": "avbarkaður eikistokkur",
  "block.minecraft.stripped_spruce_log": "avbarkaður grannstokkur",
  "block.minecraft.stripped_birch_log": "avbarkaður bjarkarstokkur",
  "block.minecraft.stripped_jungle_log": "avbarkaður frumskógarstokkur",
  "block.minecraft.stripped_acacia_log": "avbarkaður akasiubulur",
  "block.minecraft.stripped_dark_oak_log": "avbarkaður myrkur eikistokkur",
  "block.minecraft.stripped_crimson_stem": "skavaður roðastelkur",
  "block.minecraft.stripped_warped_stem": "skavaður tryglustelkur",
  "block.minecraft.stripped_oak_wood": "avbarkaður eikiviður",
  "block.minecraft.stripped_spruce_wood": "avbarkað granntræ",
  "block.minecraft.stripped_birch_wood": "avbarkaður bjarkarviður",
  "block.minecraft.stripped_jungle_wood": "avbarkaður frumskógarviður",
  "block.minecraft.stripped_acacia_wood": "avbarkað akasiutræ",
  "block.minecraft.stripped_dark_oak_wood": "avbarkaður, myrkur eikiviður",
  "block.minecraft.stripped_crimson_hyphae": "skavaðir roðasoppatræðrir",
  "block.minecraft.stripped_warped_hyphae": "skavaðir tryglusoppatræðrir",
  "block.minecraft.oak_wood": "eikiviður",
  "block.minecraft.spruce_wood": "grannviður",
  "block.minecraft.birch_wood": "bjarkarviður",
  "block.minecraft.jungle_wood": "frumskógarviður",
  "block.minecraft.acacia_wood": "akasiuviður",
  "block.minecraft.dark_oak_wood": "myrkur eikiviður",
  "block.minecraft.crimson_hyphae": "roðasoppatræðrir",
  "block.minecraft.warped_hyphae": "tryglusoppatræðrir",
  "block.minecraft.oak_leaves": "eikibløð",
  "block.minecraft.spruce_leaves": "grannnálir",
  "block.minecraft.birch_leaves": "bjarkarbløð",
  "block.minecraft.jungle_leaves": "frumskógarbløð",
  "block.minecraft.acacia_leaves": "akasiubløð",
  "block.minecraft.dark_oak_leaves": "myrk eikibløð",
  "block.minecraft.sponge": "svampur",
  "block.minecraft.wet_sponge": "vátur svampur",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "asurmálmur",
  "block.minecraft.lapis_block": "asursteinskubbi",
  "block.minecraft.dispenser": "automat",
  "block.minecraft.sandstone": "sandsteinur",
  "block.minecraft.chiseled_sandstone": "meitlaður sandsteinur",
  "block.minecraft.cut_sandstone": "skorin sandsteinur",
  "block.minecraft.note_block": "nótakubbi",
  "block.minecraft.powered_rail": "elskinnari",
  "block.minecraft.detector_rail": "sensorskinnari",
  "block.minecraft.sticky_piston": "kleptrut stempul",
  "block.minecraft.cobweb": "lokkanet",
  "block.minecraft.grass": "gras",
  "block.minecraft.fern": "trøllakampur",
  "block.minecraft.dead_bush": "deyður runnur",
  "block.minecraft.seagrass": "sjógras",
  "block.minecraft.sea_pickle": "sjóagurka",
  "block.minecraft.piston": "stempul",
  "block.minecraft.white_wool": "hvít ull",
  "block.minecraft.orange_wool": "appilsingul ull",
  "block.minecraft.magenta_wool": "viólreyð ull",
  "block.minecraft.light_blue_wool": "ljósablá ull",
  "block.minecraft.yellow_wool": "gul ull",
  "block.minecraft.lime_wool": "ljósagrøn ull",
  "block.minecraft.pink_wool": "ljósareyð ull",
  "block.minecraft.gray_wool": "grá ull",
  "block.minecraft.light_gray_wool": "ljósagrá ull",
  "block.minecraft.cyan_wool": "blágrøn ull",
  "block.minecraft.purple_wool": "lilla ull",
  "block.minecraft.blue_wool": "blá ull",
  "block.minecraft.brown_wool": "brún ull",
  "block.minecraft.green_wool": "grøn ull",
  "block.minecraft.red_wool": "reyð ull",
  "block.minecraft.black_wool": "svørt ull",
  "block.minecraft.dandelion": "hagasólja",
  "block.minecraft.poppy": "valmua",
  "block.minecraft.blue_orchid": "blá orkide",
  "block.minecraft.allium": "leykur",
  "block.minecraft.azure_bluet": "blá postalínsblóma",
  "block.minecraft.red_tulip": "reyð tulipan",
  "block.minecraft.orange_tulip": "appilsingul tulipan",
  "block.minecraft.white_tulip": "hvít tulipan",
  "block.minecraft.pink_tulip": "ljósareyð tulipan",
  "block.minecraft.oxeye_daisy": "hvítt oksaeyga",
  "block.minecraft.cornflower": "kornblóma",
  "block.minecraft.lily_of_the_valley": "dalalilja",
  "block.minecraft.wither_rose": "witherrósa",
  "block.minecraft.brown_mushroom": "brúnur soppur",
  "block.minecraft.red_mushroom": "reyður soppur",
  "block.minecraft.crimson_fungus": "roðasoppur",
  "block.minecraft.warped_fungus": "tryglusoppur",
  "block.minecraft.crimson_roots": "roðarøtur",
  "block.minecraft.warped_roots": "tryglurøtur",
  "block.minecraft.nether_sprouts": "netherspírur",
  "block.minecraft.weeping_vines": "grátandi klivurt",
  "block.minecraft.twisting_vines": "snúðrandi klivurt",
  "block.minecraft.sugar_cane": "sukurrør",
  "block.minecraft.kelp": "tari",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "gullkubbi",
  "block.minecraft.iron_block": "jarnkubbi",
  "block.minecraft.oak_slab": "eikipláta",
  "block.minecraft.spruce_slab": "grannpláta",
  "block.minecraft.birch_slab": "bjarkarpláta",
  "block.minecraft.jungle_slab": "frumskógarpláta",
  "block.minecraft.acacia_slab": "akasiupláta",
  "block.minecraft.dark_oak_slab": "myrk eikipláta",
  "block.minecraft.crimson_slab": "roðapláta",
  "block.minecraft.warped_slab": "tryglupláta",
  "block.minecraft.stone_slab": "steinpláta",
  "block.minecraft.smooth_stone_slab": "sløtt steinpláta",
  "block.minecraft.sandstone_slab": "sandsteinsflís",
  "block.minecraft.cut_sandstone_slab": "skorin sandsteinspláta",
  "block.minecraft.petrified_oak_slab": "steinrunnin eikipláta",
  "block.minecraft.cobblestone_slab": "brúgvarsteinspláta",
  "block.minecraft.brick_slab": "múrsteinspláta",
  "block.minecraft.stone_brick_slab": "steinmúrsteinspláta",
  "block.minecraft.nether_brick_slab": "nether múrsteinspláta",
  "block.minecraft.quartz_slab": "kvartspláta",
  "block.minecraft.red_sandstone_slab": "reyð sandsteinspláta",
  "block.minecraft.cut_red_sandstone_slab": "skorin reyð sandsteinspláta",
  "block.minecraft.purpur_slab": "purpurpláta",
  "block.minecraft.prismarine_slab": "prismarinpláta",
  "block.minecraft.prismarine_brick_slab": "prismarinmúrsteinspláta",
  "block.minecraft.dark_prismarine_slab": "myrk prismarinpláta",
  "block.minecraft.smooth_quartz": "sløtt kvartspláta",
  "block.minecraft.smooth_red_sandstone": "slættur reyður sandsteinur",
  "block.minecraft.smooth_sandstone": "slættur sandsteinur",
  "block.minecraft.smooth_stone": "slættur steinur",
  "block.minecraft.bricks": "múrsteinar",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "bókahill",
  "block.minecraft.mossy_cobblestone": "mosagrógvin brúgvarsteinur",
  "block.minecraft.obsidian": "obsidianur",
  "block.minecraft.torch": "kyndil",
  "block.minecraft.end_rod": "end-stong",
  "block.minecraft.chorus_plant": "niðurlagsplanta",
  "block.minecraft.chorus_flower": "niðurlagsblóma",
  "block.minecraft.purpur_block": "purpurkubbi",
  "block.minecraft.purpur_pillar": "purpursúla",
  "block.minecraft.purpur_stairs": "purpurtrappa",
  "block.minecraft.spawner": "framkallari",
  "block.minecraft.oak_stairs": "eikitrappa",
  "block.minecraft.chest": "kista",
  "block.minecraft.diamond_ore": "diamantmálmur",
  "block.minecraft.diamond_block": "diamantkubbi",
  "block.minecraft.crafting_table": "arbeiðsborð",
  "block.minecraft.farmland": "landbúnaðarjørð",
  "block.minecraft.furnace": "ovnur",
  "block.minecraft.ladder": "stigi",
  "block.minecraft.rail": "skinnari",
  "block.minecraft.cobblestone_stairs": "brúgvarsteinstrappa",
  "block.minecraft.lever": "handtak",
  "block.minecraft.stone_pressure_plate": "steintrýstpláta",
  "block.minecraft.oak_pressure_plate": "eikitrýstpláta",
  "block.minecraft.spruce_pressure_plate": "granntrýstpláta",
  "block.minecraft.birch_pressure_plate": "bjarkartrýstpláta",
  "block.minecraft.jungle_pressure_plate": "frumskógartrýstpláta",
  "block.minecraft.acacia_pressure_plate": "akasiutrýstpláta",
  "block.minecraft.dark_oak_pressure_plate": "myrk eikitrýstpláta",
  "block.minecraft.crimson_pressure_plate": "roðatrýstpláta",
  "block.minecraft.warped_pressure_plate": "tryglutrýstpláta",
  "block.minecraft.polished_blackstone_pressure_plate": "pussað svartsteinstrýstpláta",
  "block.minecraft.redstone_ore": "reyðsteinsmálmur",
  "block.minecraft.redstone_torch": "reyðsteinskyndil",
  "block.minecraft.snow": "kavi",
  "block.minecraft.ice": "ísur",
  "block.minecraft.snow_block": "kavakubbi",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "leir",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "eikigirðing",
  "block.minecraft.spruce_fence": "granngirðing",
  "block.minecraft.birch_fence": "bjarkargirðing",
  "block.minecraft.jungle_fence": "frumskógargirðing",
  "block.minecraft.acacia_fence": "akasiugirðing",
  "block.minecraft.dark_oak_fence": "myrk eikigirðing",
  "block.minecraft.crimson_fence": "roðagerðing",
  "block.minecraft.warped_fence": "tryglugirðing",
  "block.minecraft.pumpkin": "grasker",
  "block.minecraft.carved_pumpkin": "skorið grasker",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sálarsandur",
  "block.minecraft.soul_soil": "sálarmold",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polerað basalt",
  "block.minecraft.soul_torch": "sálarkyndil",
  "block.minecraft.glowstone": "glóðsteinur",
  "block.minecraft.jack_o_lantern": "graskerslanterna",
  "block.minecraft.oak_trapdoor": "eikilemmur",
  "block.minecraft.spruce_trapdoor": "grannlemmur",
  "block.minecraft.birch_trapdoor": "bjarkarlemmur",
  "block.minecraft.jungle_trapdoor": "frumskógarlemmur",
  "block.minecraft.acacia_trapdoor": "akasiulemmur",
  "block.minecraft.dark_oak_trapdoor": "myrkur eikilemmur",
  "block.minecraft.crimson_trapdoor": "roðalemmur",
  "block.minecraft.warped_trapdoor": "tryglulemmur",
  "block.minecraft.infested_stone": "smittaður steinur",
  "block.minecraft.infested_cobblestone": "smittaður brúgvarsteinur",
  "block.minecraft.infested_stone_bricks": "smittufongdur steinmúrsteinur",
  "block.minecraft.infested_mossy_stone_bricks": "smittufongdur, mosagrógvin steinmúrsteinur",
  "block.minecraft.infested_cracked_stone_bricks": "smittufongdur, rivutur steinmúrsteinur",
  "block.minecraft.infested_chiseled_stone_bricks": "smittufongdur, meitlaður steinmúrsteinur",
  "block.minecraft.stone_bricks": "steinmúrsteinur",
  "block.minecraft.mossy_stone_bricks": "mosagrógvin steinmúrsteinur",
  "block.minecraft.cracked_stone_bricks": "rivutur steinmúrsteinur",
  "block.minecraft.chiseled_stone_bricks": "meitlaður steinmúrsteinur",
  "block.minecraft.brown_mushroom_block": "brúnur soppakubbi",
  "block.minecraft.red_mushroom_block": "reyður soppakubbi",
  "block.minecraft.mushroom_stem": "soppastelkur",
  "block.minecraft.iron_bars": "jarngrindir",
  "block.minecraft.chain": "keta",
  "block.minecraft.glass_pane": "glaspanel",
  "block.minecraft.melon": "vatnmelón",
  "block.minecraft.vine": "klivurt",
  "block.minecraft.oak_fence_gate": "eikigrind",
  "block.minecraft.spruce_fence_gate": "granngrind",
  "block.minecraft.birch_fence_gate": "bjarkargrind",
  "block.minecraft.jungle_fence_gate": "frumskógargrind",
  "block.minecraft.acacia_fence_gate": "akasiugrind",
  "block.minecraft.dark_oak_fence_gate": "myrk eikigrind",
  "block.minecraft.crimson_fence_gate": "roðagrind",
  "block.minecraft.warped_fence_gate": "tryglugrind",
  "block.minecraft.brick_stairs": "múrsteinstrappa",
  "block.minecraft.stone_brick_stairs": "steinmúrsteinstrappa",
  "block.minecraft.mycelium": "soppavevnaður",
  "block.minecraft.lily_pad": "nyksblóma",
  "block.minecraft.nether_bricks": "nethermúrsteinar",
  "block.minecraft.cracked_nether_bricks": "brotnit nethermúrsteinar",
  "block.minecraft.chiseled_nether_bricks": "meitlaður niðurmúrsteinar",
  "block.minecraft.nether_brick_fence": "nethermúrsteinsgrind",
  "block.minecraft.nether_brick_stairs": "nethermúrsteinstrappa",
  "block.minecraft.enchanting_table": "gandaborð",
  "block.minecraft.end_portal_frame": "endportalarramma",
  "block.minecraft.end_stone": "endsteinur",
  "block.minecraft.end_stone_bricks": "endasteinmúrsteinur",
  "block.minecraft.dragon_egg": "drekaegg",
  "block.minecraft.redstone_lamp": "reyðsteinslampa",
  "block.minecraft.sandstone_stairs": "sandsteinstrappa",
  "block.minecraft.emerald_ore": "smaragdmálmur",
  "block.minecraft.ender_chest": "enderkista",
  "block.minecraft.tripwire_hook": "snávingartráðskrókur",
  "block.minecraft.emerald_block": "smaragdkubbi",
  "block.minecraft.spruce_stairs": "granntrappa",
  "block.minecraft.birch_stairs": "bjarkartrappa",
  "block.minecraft.jungle_stairs": "frumskógartrappa",
  "block.minecraft.crimson_stairs": "roðatrappa",
  "block.minecraft.warped_stairs": "tryglutrappa",
  "block.minecraft.command_block": "stýriboðskubbi",
  "block.minecraft.beacon": "viti",
  "block.minecraft.cobblestone_wall": "brúgvarsteinsveggur",
  "block.minecraft.mossy_cobblestone_wall": "mosagrógvin brúgvarsteinsveggur",
  "block.minecraft.brick_wall": "múrsteinsveggur",
  "block.minecraft.prismarine_wall": "prismarinveggur",
  "block.minecraft.red_sandstone_wall": "reyður sandsteinsveggur",
  "block.minecraft.mossy_stone_brick_wall": "mosagrógvin steinmúrsteinsveggur",
  "block.minecraft.granite_wall": "granittveggur",
  "block.minecraft.stone_brick_wall": "steinmúrsteinsveggur",
  "block.minecraft.nether_brick_wall": "nethermúrsteinsveggur",
  "block.minecraft.andesite_wall": "andesittveggur",
  "block.minecraft.red_nether_brick_wall": "reyð nethermúrsteinsveggur",
  "block.minecraft.sandstone_wall": "sandsteinsveggur",
  "block.minecraft.end_stone_brick_wall": "endasteinmúrsteinsveggur",
  "block.minecraft.diorite_wall": "diorittveggur",
  "block.minecraft.blackstone_wall": "svartsteinsveggur",
  "block.minecraft.polished_blackstone_wall": "pussaður svartsteinsveggur",
  "block.minecraft.polished_blackstone_brick_wall": "pussaður svartsteinmúrsteinsveggur",
  "block.minecraft.stone_button": "steinknøttur",
  "block.minecraft.oak_button": "eikiknøttur",
  "block.minecraft.spruce_button": "grannknøttur",
  "block.minecraft.birch_button": "bjarkarknøttur",
  "block.minecraft.jungle_button": "frumskóðarknøttur",
  "block.minecraft.acacia_button": "akasiuknøttur",
  "block.minecraft.dark_oak_button": "myrkur eikiknøttur",
  "block.minecraft.crimson_button": "roðaknappur",
  "block.minecraft.warped_button": "trygluknappur",
  "block.minecraft.polished_blackstone_button": "pussaður svartsteinsknøttur",
  "block.minecraft.anvil": "amboltur",
  "block.minecraft.chipped_anvil": "skaraður amboltur",
  "block.minecraft.damaged_anvil": "illa farin amboltur",
  "block.minecraft.trapped_chest": "fellukista",
  "block.minecraft.light_weighted_pressure_plate": "lættvigað trýstpláta",
  "block.minecraft.heavy_weighted_pressure_plate": "tungvigað trýstpláta",
  "block.minecraft.daylight_detector": "dagsljóssensorur",
  "block.minecraft.redstone_block": "reyðsteinskubbi",
  "block.minecraft.nether_quartz_ore": "netherkvartsgrýti",
  "block.minecraft.hopper": "trakt",
  "block.minecraft.chiseled_quartz_block": "meitlaður kvartskubbi",
  "block.minecraft.quartz_block": "kvartskubbi",
  "block.minecraft.quartz_bricks": "kvartsmúrsteinar",
  "block.minecraft.quartz_pillar": "kvartssúla",
  "block.minecraft.quartz_stairs": "kvartstrappa",
  "block.minecraft.activator_rail": "virkingarskinnari",
  "block.minecraft.dropper": "skamtari",
  "block.minecraft.white_terracotta": "hvítt terrakotta",
  "block.minecraft.orange_terracotta": "appilsingult terrakotta",
  "block.minecraft.magenta_terracotta": "viólreytt terrakotta",
  "block.minecraft.light_blue_terracotta": "ljósablátt terrakotta",
  "block.minecraft.yellow_terracotta": "gult terrakotta",
  "block.minecraft.lime_terracotta": "ljósagrønt terrakotta",
  "block.minecraft.pink_terracotta": "ljósareytt terrakotta",
  "block.minecraft.gray_terracotta": "grátt terrakotta",
  "block.minecraft.light_gray_terracotta": "ljósagrátt terrakotta",
  "block.minecraft.cyan_terracotta": "blágrønt terrakotta",
  "block.minecraft.purple_terracotta": "lilla terrakotta",
  "block.minecraft.blue_terracotta": "blátt terrakotta",
  "block.minecraft.brown_terracotta": "brúnt terrakotta",
  "block.minecraft.green_terracotta": "grønt terrakotta",
  "block.minecraft.red_terracotta": "reytt terrakotta",
  "block.minecraft.black_terracotta": "svart terrakotta",
  "block.minecraft.barrier": "forðing",
  "block.minecraft.iron_trapdoor": "jarnlemmur",
  "block.minecraft.hay_block": "hoyballa",
  "block.minecraft.white_carpet": "hvítt teppi",
  "block.minecraft.orange_carpet": "appilsingult teppi",
  "block.minecraft.magenta_carpet": "viólreytt teppi",
  "block.minecraft.light_blue_carpet": "ljósablátt teppi",
  "block.minecraft.yellow_carpet": "gult teppi",
  "block.minecraft.lime_carpet": "ljósagrønt teppi",
  "block.minecraft.pink_carpet": "ljósareytt teppi",
  "block.minecraft.gray_carpet": "grátt teppi",
  "block.minecraft.light_gray_carpet": "ljósagrátt teppi",
  "block.minecraft.cyan_carpet": "blágrønt teppi",
  "block.minecraft.purple_carpet": "lilla teppi",
  "block.minecraft.blue_carpet": "blátt teppi",
  "block.minecraft.brown_carpet": "brúnt teppi",
  "block.minecraft.green_carpet": "grønt teppi",
  "block.minecraft.red_carpet": "reytt teppi",
  "block.minecraft.black_carpet": "svart teppi",
  "block.minecraft.terracotta": "terrakotta",
  "block.minecraft.coal_block": "kolakubbi",
  "block.minecraft.packed_ice": "pakkaður ísur",
  "block.minecraft.acacia_stairs": "akasiutrappa",
  "block.minecraft.dark_oak_stairs": "myrk eikitrappa",
  "block.minecraft.slime_block": "slímkubbi",
  "block.minecraft.grass_path": "grasrás",
  "block.minecraft.sunflower": "sólblóma",
  "block.minecraft.lilac": "sírena",
  "block.minecraft.rose_bush": "rósurunnur",
  "block.minecraft.peony": "bóndarósa",
  "block.minecraft.tall_grass": "høgt gras",
  "block.minecraft.large_fern": "stórur trøllakampur",
  "block.minecraft.white_stained_glass": "hvítt litað glas",
  "block.minecraft.orange_stained_glass": "appilsingult litað glas",
  "block.minecraft.magenta_stained_glass": "viólreytt litað glas",
  "block.minecraft.light_blue_stained_glass": "ljósablátt litað glas",
  "block.minecraft.yellow_stained_glass": "gult litað glas",
  "block.minecraft.lime_stained_glass": "ljósagrønt litað glas",
  "block.minecraft.pink_stained_glass": "ljósareytt litað glas",
  "block.minecraft.gray_stained_glass": "grátt litað glas",
  "block.minecraft.light_gray_stained_glass": "ljósagrátt litað glas",
  "block.minecraft.cyan_stained_glass": "blágrønt litað glas",
  "block.minecraft.purple_stained_glass": "lilla litað glas",
  "block.minecraft.blue_stained_glass": "blátt litað glas",
  "block.minecraft.brown_stained_glass": "brúnlitt litað glas",
  "block.minecraft.green_stained_glass": "grønt litað gras",
  "block.minecraft.red_stained_glass": "reytt litað glas",
  "block.minecraft.black_stained_glass": "svart litað glas",
  "block.minecraft.white_stained_glass_pane": "hvítt litað glaspanel",
  "block.minecraft.orange_stained_glass_pane": "appilsingult litað glaspanel",
  "block.minecraft.magenta_stained_glass_pane": "viólreytt litað glaspanel",
  "block.minecraft.light_blue_stained_glass_pane": "ljósablátt litað glaspanel",
  "block.minecraft.yellow_stained_glass_pane": "gult litað glaspanel",
  "block.minecraft.lime_stained_glass_pane": "ljósagrønt litað glaspanel",
  "block.minecraft.pink_stained_glass_pane": "ljósareytt litað glaspanel",
  "block.minecraft.gray_stained_glass_pane": "grátt litað glaspanel",
  "block.minecraft.light_gray_stained_glass_pane": "ljósagrátt litað glaspanel",
  "block.minecraft.cyan_stained_glass_pane": "blágrønt litað glaspanel",
  "block.minecraft.purple_stained_glass_pane": "lilla litað glaspanel",
  "block.minecraft.blue_stained_glass_pane": "blátt litað glaspanel",
  "block.minecraft.brown_stained_glass_pane": "brúnt litað glaspanel",
  "block.minecraft.green_stained_glass_pane": "grønt litað glaspanel",
  "block.minecraft.red_stained_glass_pane": "reytt litað glaspanel",
  "block.minecraft.black_stained_glass_pane": "svart litað glaspanel",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "prismarinmúrsteinar",
  "block.minecraft.dark_prismarine": "myrk prismarin",
  "block.minecraft.prismarine_stairs": "prismarintrappa",
  "block.minecraft.prismarine_brick_stairs": "prismarinmúrsteinstrappa",
  "block.minecraft.dark_prismarine_stairs": "myrk prismarintrappa",
  "block.minecraft.sea_lantern": "sjólanterna",
  "block.minecraft.red_sandstone": "reyður sandsteinur",
  "block.minecraft.chiseled_red_sandstone": "meitlaður reyður sandsteinur",
  "block.minecraft.cut_red_sandstone": "skorin reyður sandsteinur",
  "block.minecraft.red_sandstone_stairs": "reyð sandsteinstrappa",
  "block.minecraft.repeating_command_block": "endurtakandi stýriboðskubbi",
  "block.minecraft.chain_command_block": "ketustýriboðskubbi",
  "block.minecraft.magma_block": "magmakubbi",
  "block.minecraft.nether_wart_block": "netherkubbi",
  "block.minecraft.warped_wart_block": "tryglunetherfinnarkubbi",
  "block.minecraft.red_nether_bricks": "reyðir nethermúrsteinar",
  "block.minecraft.bone_block": "beinkubbi",
  "block.minecraft.structure_void": "tómrúmsstrukturur",
  "block.minecraft.observer": "eygleiðari",
  "block.minecraft.shulker_box": "shulkerkassi",
  "block.minecraft.white_shulker_box": "hvítur shulkerkassi",
  "block.minecraft.orange_shulker_box": "appilsingulur shulkerkassi",
  "block.minecraft.magenta_shulker_box": "viólreyður shulkerkassi",
  "block.minecraft.light_blue_shulker_box": "ljósabláur shulkerkassi",
  "block.minecraft.yellow_shulker_box": "gulur shulkerkassi",
  "block.minecraft.lime_shulker_box": "ljósagrønur shulkerkassi",
  "block.minecraft.pink_shulker_box": "ljósareyður shulkerkassi",
  "block.minecraft.gray_shulker_box": "gráur shulkerkassi",
  "block.minecraft.light_gray_shulker_box": "ljósagráur shulkerkassi",
  "block.minecraft.cyan_shulker_box": "blágrønur shulkerkassi",
  "block.minecraft.purple_shulker_box": "lillaður shulkerkassi",
  "block.minecraft.blue_shulker_box": "bláur shulkerkassi",
  "block.minecraft.brown_shulker_box": "brúnur shulkerkassi",
  "block.minecraft.green_shulker_box": "grønur shulkerkassi",
  "block.minecraft.red_shulker_box": "reyður shulkerkassi",
  "block.minecraft.black_shulker_box": "svartur shulkerkassi",
  "block.minecraft.white_glazed_terracotta": "hvítt glaserað terrakotta",
  "block.minecraft.orange_glazed_terracotta": "appilsingult glaserað terrakotta",
  "block.minecraft.magenta_glazed_terracotta": "viólreytt glaserað terrakotta",
  "block.minecraft.light_blue_glazed_terracotta": "ljósablátt glaserað terrakotta",
  "block.minecraft.yellow_glazed_terracotta": "gult glaserað terrakotta",
  "block.minecraft.lime_glazed_terracotta": "ljósagrønt glaserað terrakotta",
  "block.minecraft.pink_glazed_terracotta": "ljósareytt glaserað terrakotta",
  "block.minecraft.gray_glazed_terracotta": "grátt glaserað terrakotta",
  "block.minecraft.light_gray_glazed_terracotta": "ljósagrátt glaserað terrakotta",
  "block.minecraft.cyan_glazed_terracotta": "blágrønt glaserað terrakotta",
  "block.minecraft.purple_glazed_terracotta": "lilla glaserað terrakotta",
  "block.minecraft.blue_glazed_terracotta": "blátt glaserað terrakotta",
  "block.minecraft.brown_glazed_terracotta": "brúnt glaserað terrakotta",
  "block.minecraft.green_glazed_terracotta": "grønt glaserað terrakotta",
  "block.minecraft.red_glazed_terracotta": "reytt glaserað terrakotta",
  "block.minecraft.black_glazed_terracotta": "svart glaserað terrakotta",
  "block.minecraft.white_concrete": "hvítt betong",
  "block.minecraft.orange_concrete": "appilsingult betong",
  "block.minecraft.magenta_concrete": "viólreytt betong",
  "block.minecraft.light_blue_concrete": "ljósablátt betong",
  "block.minecraft.yellow_concrete": "gult betong",
  "block.minecraft.lime_concrete": "ljósagrønt betong",
  "block.minecraft.pink_concrete": "ljósareytt betong",
  "block.minecraft.gray_concrete": "grátt betong",
  "block.minecraft.light_gray_concrete": "ljósagrátt betong",
  "block.minecraft.cyan_concrete": "blágrønt betong",
  "block.minecraft.purple_concrete": "lilla betong",
  "block.minecraft.blue_concrete": "blátt betong",
  "block.minecraft.brown_concrete": "brúnt betong",
  "block.minecraft.green_concrete": "grønt betong",
  "block.minecraft.red_concrete": "reytt betong",
  "block.minecraft.black_concrete": "svart betong",
  "block.minecraft.white_concrete_powder": "hvítt betongpulvur",
  "block.minecraft.orange_concrete_powder": "appilsingult betongpulvur",
  "block.minecraft.magenta_concrete_powder": "viólreytt betongpulvur",
  "block.minecraft.light_blue_concrete_powder": "ljósablátt betongpulvur",
  "block.minecraft.yellow_concrete_powder": "gult betongpulvur",
  "block.minecraft.lime_concrete_powder": "ljósagrønt betongpulvur",
  "block.minecraft.pink_concrete_powder": "ljósareytt betongpulvur",
  "block.minecraft.gray_concrete_powder": "grátt betongpulvur",
  "block.minecraft.light_gray_concrete_powder": "ljósagrátt betongpulvur",
  "block.minecraft.cyan_concrete_powder": "blágrønt betongpulvur",
  "block.minecraft.purple_concrete_powder": "lilla betongpulvur",
  "block.minecraft.blue_concrete_powder": "blátt betongpulvur",
  "block.minecraft.brown_concrete_powder": "brúnt betongpulvur",
  "block.minecraft.green_concrete_powder": "grønt betongpulvur",
  "block.minecraft.red_concrete_powder": "reytt betongpulvur",
  "block.minecraft.black_concrete_powder": "svart betongpulvur",
  "block.minecraft.turtle_egg": "skjaldbøkuegg",
  "block.minecraft.dead_tube_coral_block": "deyður pípukorallkubbi",
  "block.minecraft.dead_brain_coral_block": "deyður heilakorallkubbi",
  "block.minecraft.dead_bubble_coral_block": "deyður bløðrukorallkubbi",
  "block.minecraft.dead_fire_coral_block": "deyður eldkorallkubbi",
  "block.minecraft.dead_horn_coral_block": "deyður hornkorallkubbi",
  "block.minecraft.tube_coral_block": "pípukorallkubbi",
  "block.minecraft.brain_coral_block": "heilakorallkubbi",
  "block.minecraft.bubble_coral_block": "bløðrukorallkubbi",
  "block.minecraft.fire_coral_block": "eldkorallkubbi",
  "block.minecraft.horn_coral_block": "hornkorallkubbi",
  "block.minecraft.tube_coral": "pípukorall",
  "block.minecraft.brain_coral": "heilakorall",
  "block.minecraft.bubble_coral": "bløðrukorall",
  "block.minecraft.fire_coral": "eldkorall",
  "block.minecraft.horn_coral": "hornkorall",
  "block.minecraft.dead_brain_coral": "deyð heilakorall",
  "block.minecraft.dead_bubble_coral": "deyð bløðrukorall",
  "block.minecraft.dead_fire_coral": "deyð eldkorall",
  "block.minecraft.dead_horn_coral": "deyð hornkorall",
  "block.minecraft.dead_tube_coral": "deyð pípukorall",
  "block.minecraft.tube_coral_fan": "pípukorallveiftra",
  "block.minecraft.brain_coral_fan": "heilakorallveiftra",
  "block.minecraft.bubble_coral_fan": "bløðrukorallveiftra",
  "block.minecraft.fire_coral_fan": "eldkorallveiftra",
  "block.minecraft.horn_coral_fan": "hornkorallveiftra",
  "block.minecraft.dead_tube_coral_fan": "deyð pípukorallveiftra",
  "block.minecraft.dead_brain_coral_fan": "deyð heilakorallveiftra",
  "block.minecraft.dead_bubble_coral_fan": "deyð bløðrukorallveiftra",
  "block.minecraft.dead_fire_coral_fan": "deyð eldkorallveiftra",
  "block.minecraft.dead_horn_coral_fan": "deyð hornkorallveiftra",
  "block.minecraft.blue_ice": "bláur ísur",
  "block.minecraft.conduit": "fløðari",
  "block.minecraft.polished_granite_stairs": "pussað granitttrappa",
  "block.minecraft.smooth_red_sandstone_stairs": "sløtt, reyð sandsteinstrappa",
  "block.minecraft.mossy_stone_brick_stairs": "mosagrógvin steinmúrsteinstrappa",
  "block.minecraft.polished_diorite_stairs": "pussað dioritttrappa",
  "block.minecraft.mossy_cobblestone_stairs": "mosagrógvin brúgvarsteinstrappa",
  "block.minecraft.end_stone_brick_stairs": "endamúrsteinstrappa",
  "block.minecraft.stone_stairs": "steintrappa",
  "block.minecraft.smooth_sandstone_stairs": "sløtt sandsteinstrappa",
  "block.minecraft.smooth_quartz_stairs": "sløtt kvartstrappa",
  "block.minecraft.granite_stairs": "granitttrappa",
  "block.minecraft.andesite_stairs": "andesitttrappa",
  "block.minecraft.red_nether_brick_stairs": "reyð nethermúrsteinstrappa",
  "block.minecraft.polished_andesite_stairs": "pussað andesitttrappa",
  "block.minecraft.diorite_stairs": "dioritttrappa",
  "block.minecraft.polished_granite_slab": "pussað granittpláta",
  "block.minecraft.smooth_red_sandstone_slab": "reyð, sløtt sandsteinspláta",
  "block.minecraft.mossy_stone_brick_slab": "mosagrógvin múrsteinspláta",
  "block.minecraft.polished_diorite_slab": "pussað diorittpláta",
  "block.minecraft.mossy_cobblestone_slab": "mosagrógvin brúgvarsteinspláta",
  "block.minecraft.end_stone_brick_slab": "endamúrsteinspláta",
  "block.minecraft.smooth_sandstone_slab": "sløtt sandsteinspláta",
  "block.minecraft.smooth_quartz_slab": "sløtt kvartspláta",
  "block.minecraft.granite_slab": "granittpláta",
  "block.minecraft.andesite_slab": "andesittpláta",
  "block.minecraft.red_nether_brick_slab": "reyð nethermúrsteinspláta",
  "block.minecraft.polished_andesite_slab": "pussað andesittpláta",
  "block.minecraft.diorite_slab": "diorittpláta",
  "block.minecraft.scaffolding": "arbeiðspallur",
  "block.minecraft.iron_door": "jarnhurð",
  "block.minecraft.oak_door": "eikihurð",
  "block.minecraft.spruce_door": "grannhurð",
  "block.minecraft.birch_door": "bjarkarhurð",
  "block.minecraft.jungle_door": "frumskógarhurð",
  "block.minecraft.acacia_door": "akasiuhurð",
  "block.minecraft.dark_oak_door": "myrk eikihurð",
  "block.minecraft.crimson_door": "roðahurð",
  "block.minecraft.warped_door": "trygluhurð",
  "block.minecraft.repeater": "reyðsteinsendurtakari",
  "block.minecraft.comparator": "reyðsteinssamanberi",
  "block.minecraft.structure_block": "byggingarkubbi",
  "block.minecraft.jigsaw": "putlispælskubbi",
  "item.minecraft.turtle_helmet": "skjaldbøkuskel□□when on head:□+2 brynja",
  "item.minecraft.scute": "skel",
  "item.minecraft.iron_shovel": "jarnspaki□□when in main hand:□+3.5 álopsskaði□-3 álopsferð",
  "item.minecraft.iron_pickaxe": "jarnhakkari□□when in main hand:□+3 álopsskaði□-2.8 álopsferð",
  "item.minecraft.iron_axe": "jarnøks□□when in main hand:□+8 álopsskaði□-3.1 álopsferð",
  "item.minecraft.flint_and_steel": "tinna og stál",
  "item.minecraft.apple": "súrepli",
  "item.minecraft.bow": "bogi",
  "item.minecraft.arrow": "ørvur",
  "item.minecraft.coal": "kol",
  "item.minecraft.charcoal": "trækol",
  "item.minecraft.diamond": "diamantur",
  "item.minecraft.iron_ingot": "jarnstong",
  "item.minecraft.gold_ingot": "gullstong",
  "item.minecraft.netherite_ingot": "netherittstong",
  "item.minecraft.netherite_scrap": "netherittfras",
  "item.minecraft.iron_sword": "jarnsvørð□□when in main hand:□+5 álopsskaði□-2.4 álopsferð",
  "item.minecraft.wooden_sword": "træsvørð□□when in main hand:□+3 álopsskaði□-2.4 álopsferð",
  "item.minecraft.wooden_shovel": "træspaki□□when in main hand:□+1.5 álopsskaði□-3 álopsferð",
  "item.minecraft.wooden_pickaxe": "træhakkari□□when in main hand:□+1 álopsskaði□-2.8 álopsferð",
  "item.minecraft.wooden_axe": "træøks□□when in main hand:□+6 álopsskaði□-3.2 álopsferð",
  "item.minecraft.stone_sword": "steinsvørð□□when in main hand:□+4 álopsskaði□-2.4 álopsferð",
  "item.minecraft.stone_shovel": "steinspaki□□when in main hand:□+2.5 álopsskaði□-3 álopsferð",
  "item.minecraft.stone_pickaxe": "steinhakkari□□when in main hand:□+2 álopsskaði□-2.8 álopsferð",
  "item.minecraft.stone_axe": "steinøks□□when in main hand:□+8 álopsskaði□-3.2 álopsferð",
  "item.minecraft.diamond_sword": "diamantsvørð□□when in main hand:□+6 álopsskaði□-2.4 álopsferð",
  "item.minecraft.diamond_shovel": "diamantspaki□□when in main hand:□+4.5 álopsskaði□-3 álopsferð",
  "item.minecraft.diamond_pickaxe": "diamanthakkari□□when in main hand:□+4 álopsskaði□-2.8 álopsferð",
  "item.minecraft.diamond_axe": "diamantøks□□when in main hand:□+8 álopsskaði□-3 álopsferð",
  "item.minecraft.stick": "pinnur",
  "item.minecraft.bowl": "bolli",
  "item.minecraft.mushroom_stew": "soppastúvningur",
  "item.minecraft.golden_sword": "gullsvørð□□when in main hand:□+3 álopsskaði□-2.4 álopsferð",
  "item.minecraft.golden_shovel": "gullspaki□□when in main hand:□+1.5 álopsskaði□-3 álopsferð",
  "item.minecraft.golden_pickaxe": "gullhakkari□□when in main hand:□+1 álopsskaði□-2.8 álopsferð",
  "item.minecraft.golden_axe": "gulløks□□when in main hand:□+6 álopsskaði□-3 álopsferð",
  "item.minecraft.netherite_sword": "netherittsvørð□□when in main hand:□+7 álopsskaði□-2.4 álopsferð",
  "item.minecraft.netherite_shovel": "netherittspaki□□when in main hand:□+5.5 álopsskaði□-3 álopsferð",
  "item.minecraft.netherite_pickaxe": "netheritthakkari□□when in main hand:□+5 álopsskaði□-2.8 álopsferð",
  "item.minecraft.netherite_axe": "netherittøks□□when in main hand:□+9 álopsskaði□-3 álopsferð",
  "item.minecraft.string": "tráður",
  "item.minecraft.feather": "fjøður",
  "item.minecraft.gunpowder": "krút",
  "item.minecraft.wooden_hoe": "træ-lúkijarn□□when in main hand:□-3 álopsferð",
  "item.minecraft.stone_hoe": "stein-lúkijarn□□when in main hand:□-2 álopsferð",
  "item.minecraft.iron_hoe": "jarn-lúkijarn□□when in main hand:□-1 álopsferð",
  "item.minecraft.diamond_hoe": "diamant-lúkijarn□□when in main hand:",
  "item.minecraft.golden_hoe": "gull-lúkijarn□□when in main hand:□-3 álopsferð",
  "item.minecraft.netherite_hoe": "netherittlúkijarn□□when in main hand:",
  "item.minecraft.wheat_seeds": "hveitifræ",
  "item.minecraft.wheat": "hveiti",
  "item.minecraft.bread": "breyð",
  "item.minecraft.leather_helmet": "leðurhattur□□when on head:□+1 brynja",
  "item.minecraft.leather_chestplate": "leðurjakki□□when on body:□+3 brynja",
  "item.minecraft.leather_leggings": "leðurbuksur□□when on legs:□+2 brynja",
  "item.minecraft.leather_boots": "leðurstivlar□□when on feet:□+1 brynja",
  "item.minecraft.chainmail_helmet": "ringbrynjuhjálmur□□when on head:□+2 brynja",
  "item.minecraft.chainmail_chestplate": "ringbrynja□□when on body:□+5 brynja",
  "item.minecraft.chainmail_leggings": "ringbrynjubuksur□□when on legs:□+4 brynja",
  "item.minecraft.chainmail_boots": "ringbrynjustivlar□□when on feet:□+1 brynja",
  "item.minecraft.iron_helmet": "jarnhjálmur□□when on head:□+2 brynja",
  "item.minecraft.iron_chestplate": "jarnbrynja□□when on body:□+6 brynja",
  "item.minecraft.iron_leggings": "jarnbuksur□□when on legs:□+5 brynja",
  "item.minecraft.iron_boots": "jarnstivlar□□when on feet:□+2 brynja",
  "item.minecraft.diamond_helmet": "diamanthjálmur□□when on head:□+3 brynja□+2 brynjustyrki",
  "item.minecraft.diamond_chestplate": "diamantbrynja□□when on body:□+8 brynja□+2 brynjustyrki",
  "item.minecraft.diamond_leggings": "diamantbuksur□□when on legs:□+6 brynja□+2 brynjustyrki",
  "item.minecraft.diamond_boots": "diamantstivlar□□when on feet:□+3 brynja□+2 brynjustyrki",
  "item.minecraft.golden_helmet": "gullhjálmur□□when on head:□+2 brynja",
  "item.minecraft.golden_chestplate": "gullbrynja□□when on body:□+5 brynja",
  "item.minecraft.golden_leggings": "gullbuksur□□when on legs:□+3 brynja",
  "item.minecraft.golden_boots": "gullstivlar□□when on feet:□+1 brynja",
  "item.minecraft.netherite_helmet": "netheritthjálmur□□when on head:□+3 brynja□+3 brynjustyrki□+1 bakslagsverja",
  "item.minecraft.netherite_chestplate": "netherittbrynja□□when on body:□+8 brynja□+3 brynjustyrki□+1 bakslagsverja",
  "item.minecraft.netherite_leggings": "netherittbuksur□□when on legs:□+6 brynja□+3 brynjustyrki□+1 bakslagsverja",
  "item.minecraft.netherite_boots": "netherittstivlar□□when on feet:□+3 brynja□+3 brynjustyrki□+1 bakslagsverja",
  "item.minecraft.flint": "tinna",
  "item.minecraft.porkchop": "rá svínakotelett",
  "item.minecraft.cooked_porkchop": "kókað svínakotelett",
  "item.minecraft.painting": "málarí",
  "item.minecraft.golden_apple": "gylt súrepli",
  "item.minecraft.enchanted_golden_apple": "gandað gylt súrepli",
  "block.minecraft.oak_sign": "eikiskelti",
  "block.minecraft.spruce_sign": "grannskelti",
  "block.minecraft.birch_sign": "bjarkarskelti",
  "block.minecraft.jungle_sign": "frumskógarskelti",
  "block.minecraft.acacia_sign": "akasiuskelti",
  "block.minecraft.dark_oak_sign": "myrkt eikiskelti",
  "block.minecraft.crimson_sign": "roðaskelti",
  "block.minecraft.warped_sign": "trygluskelti",
  "item.minecraft.bucket": "spann",
  "item.minecraft.water_bucket": "vatnspann",
  "item.minecraft.lava_bucket": "lavaspann",
  "item.minecraft.minecart": "námsvognur",
  "item.minecraft.saddle": "saðil",
  "item.minecraft.redstone": "reyðsteinsdust",
  "item.minecraft.snowball": "kavablak",
  "item.minecraft.oak_boat": "eikibátur",
  "item.minecraft.leather": "leður",
  "item.minecraft.milk_bucket": "dylla",
  "item.minecraft.pufferfish_bucket": "spann við ígulfiski",
  "item.minecraft.salmon_bucket": "spann við laksi",
  "item.minecraft.cod_bucket": "spann við toski",
  "item.minecraft.tropical_fish_bucket": "spann við tropiskum fiski",
  "item.minecraft.brick": "múrsteinur",
  "item.minecraft.clay_ball": "leirbóltur",
  "block.minecraft.dried_kelp_block": "turkaður tarakubbi",
  "item.minecraft.paper": "pappír",
  "item.minecraft.book": "bók",
  "item.minecraft.slime_ball": "slímbóltur",
  "item.minecraft.chest_minecart": "námsvognur við kistu",
  "item.minecraft.furnace_minecart": "námsvognur við ovni",
  "item.minecraft.egg": "egg",
  "item.minecraft.compass": "kumpass",
  "item.minecraft.fishing_rod": "tráða",
  "item.minecraft.clock": "klokka",
  "item.minecraft.glowstone_dust": "gløðisteinspulvur",
  "item.minecraft.cod": "ráur toskur",
  "item.minecraft.salmon": "ráur laksur",
  "item.minecraft.tropical_fish": "tropiskur fiskur",
  "item.minecraft.pufferfish": "ígulfiskur",
  "item.minecraft.cooked_cod": "kókaður toskur",
  "item.minecraft.cooked_salmon": "kókaður laksur",
  "item.minecraft.ink_sac": "blekkposi",
  "item.minecraft.red_dye": "reytt litevni",
  "item.minecraft.green_dye": "grønt litevni",
  "item.minecraft.cocoa_beans": "kakaobønir",
  "item.minecraft.lapis_lazuli": "asursteinur",
  "item.minecraft.purple_dye": "lilla litevni",
  "item.minecraft.cyan_dye": "blágrønt litevni",
  "item.minecraft.light_gray_dye": "ljósagrátt litevni",
  "item.minecraft.gray_dye": "grátt litevni",
  "item.minecraft.pink_dye": "ljósareytt litevni",
  "item.minecraft.lime_dye": "ljósagrønt litevni",
  "item.minecraft.yellow_dye": "gult litevni",
  "item.minecraft.light_blue_dye": "ljósablátt litevni",
  "item.minecraft.magenta_dye": "viólreytt litevni",
  "item.minecraft.orange_dye": "appilsingult litevni",
  "item.minecraft.bone_meal": "beinmjøl",
  "item.minecraft.blue_dye": "blátt litevni",
  "item.minecraft.brown_dye": "brúnt litevni",
  "item.minecraft.black_dye": "svart litevni",
  "item.minecraft.white_dye": "hvítt litevni",
  "item.minecraft.bone": "bein",
  "item.minecraft.sugar": "sukur",
  "block.minecraft.cake": "køka",
  "block.minecraft.white_bed": "hvít song",
  "block.minecraft.orange_bed": "appilsingul song",
  "block.minecraft.magenta_bed": "viólreyð song",
  "block.minecraft.light_blue_bed": "ljósablá song",
  "block.minecraft.yellow_bed": "gul song",
  "block.minecraft.lime_bed": "ljósagrøn song",
  "block.minecraft.pink_bed": "ljósareyð song",
  "block.minecraft.gray_bed": "grá song",
  "block.minecraft.light_gray_bed": "ljósagrá song",
  "block.minecraft.cyan_bed": "blágrøn song",
  "block.minecraft.purple_bed": "lilla song",
  "block.minecraft.blue_bed": "blá song",
  "block.minecraft.brown_bed": "brún song",
  "block.minecraft.green_bed": "grøn song",
  "block.minecraft.red_bed": "reyð song",
  "block.minecraft.black_bed": "svørt song",
  "item.minecraft.cookie": "smákøka",
  "item.minecraft.filled_map": "kort□#0",
  "item.minecraft.shears": "saksur",
  "item.minecraft.melon_slice": "vatnmelónsflís",
  "item.minecraft.dried_kelp": "turkaður tari",
  "item.minecraft.pumpkin_seeds": "graskerjafræ",
  "item.minecraft.melon_seeds": "vatnmelónsfræ",
  "item.minecraft.beef": "rátt oksakjøt",
  "item.minecraft.cooked_beef": "búffur",
  "item.minecraft.chicken": "ráur høsnarungi",
  "item.minecraft.cooked_chicken": "kókaður høsnarungi",
  "item.minecraft.rotten_flesh": "rotið kjøt",
  "item.minecraft.ender_pearl": "ender-perla",
  "item.minecraft.blaze_rod": "logastavur",
  "item.minecraft.ghast_tear": "dreygatár",
  "item.minecraft.gold_nugget": "gullklumpur",
  "item.minecraft.nether_wart": "nethervarta",
  "item.minecraft.potion": "ikki-evnaligur drykkur□ongar effektir",
  "item.minecraft.glass_bottle": "glasfløska",
  "item.minecraft.spider_eye": "eiturkoppaeyga",
  "item.minecraft.fermented_spider_eye": "ræst eiturkoppaeyga",
  "item.minecraft.blaze_powder": "blazepulvur",
  "item.minecraft.magma_cream": "magmakrem",
  "block.minecraft.brewing_stand": "bryggistøð",
  "block.minecraft.cauldron": "grýta",
  "item.minecraft.ender_eye": "endereyga",
  "item.minecraft.glistering_melon_slice": "glitrandi vatnmelónsflís",
  "item.minecraft.bat_spawn_egg": "framkallingaregg fyri flogmús",
  "item.minecraft.bee_spawn_egg": "framkallingaregg fyri býflugu",
  "item.minecraft.blaze_spawn_egg": "framkallingaregg fyri blaze",
  "item.minecraft.cat_spawn_egg": "framkallingaregg fyri kettu",
  "item.minecraft.cave_spider_spawn_egg": "framkallingaregg fyri helliseiturkopp",
  "item.minecraft.chicken_spawn_egg": "framkallingaregg fyri hønu",
  "item.minecraft.cod_spawn_egg": "framkallingaregg fyri tosk",
  "item.minecraft.cow_spawn_egg": "framkallingaregg fyri kúgv",
  "item.minecraft.creeper_spawn_egg": "framkallingaregg fyri creeper",
  "item.minecraft.dolphin_spawn_egg": "framkallingaregg fyri delfin",
  "item.minecraft.donkey_spawn_egg": "framkallingaregg fyri asna",
  "item.minecraft.drowned_spawn_egg": "druknað framkallingaregg",
  "item.minecraft.elder_guardian_spawn_egg": "framkallingaregg fyri gamlan verndara",
  "item.minecraft.enderman_spawn_egg": "framkallingaregg fyri endermann",
  "item.minecraft.endermite_spawn_egg": "framkallingaregg fyri endermite",
  "item.minecraft.evoker_spawn_egg": "framkallingaregg fyri vekjara",
  "item.minecraft.fox_spawn_egg": "framkallingaregg fyri rev",
  "item.minecraft.ghast_spawn_egg": "framkallingaregg fyri ghast",
  "item.minecraft.guardian_spawn_egg": "framkallingaregg fyri verndara",
  "item.minecraft.hoglin_spawn_egg": "framkallingaregg fyri hoglin",
  "item.minecraft.horse_spawn_egg": "framkallingaregg fyri ross",
  "item.minecraft.husk_spawn_egg": "framkallingaregg fyri reynazombie",
  "item.minecraft.llama_spawn_egg": "framkallingaregg fyri lama",
  "item.minecraft.magma_cube_spawn_egg": "framkallingaregg fyri magmakubba",
  "item.minecraft.mooshroom_spawn_egg": "framkallingaregg fyri mooshroom",
  "item.minecraft.mule_spawn_egg": "framkallingaregg fyri múldýr",
  "item.minecraft.ocelot_spawn_egg": "framkallingaregg fyri villkatt",
  "item.minecraft.panda_spawn_egg": "framkallingaregg fyri pandu",
  "item.minecraft.parrot_spawn_egg": "framkallingaregg fyri pappageyk",
  "item.minecraft.phantom_spawn_egg": "framkallingaregg fyri dreyg",
  "item.minecraft.pig_spawn_egg": "framkallingaregg fyri grís",
  "item.minecraft.piglin_spawn_egg": "framkallingaregg fyri piglin",
  "item.minecraft.pillager_spawn_egg": "framkallingaregg fyri ránsfólk",
  "item.minecraft.polar_bear_spawn_egg": "framkallingaregg fyri ísbjørn",
  "item.minecraft.pufferfish_spawn_egg": "framkallingaregg fyri kúlufisk",
  "item.minecraft.rabbit_spawn_egg": "framkallingaregg fyri kanin",
  "item.minecraft.ravager_spawn_egg": "framkallingaregg fyri herjara",
  "item.minecraft.salmon_spawn_egg": "framkallingaregg fyri laks",
  "item.minecraft.sheep_spawn_egg": "framkallingaregg fyri seyð",
  "item.minecraft.shulker_spawn_egg": "framkallingaregg fyri shulker",
  "item.minecraft.silverfish_spawn_egg": "framkallingaregg fyri silvurfisk",
  "item.minecraft.skeleton_spawn_egg": "framkallingaregg fyri beinagrind",
  "item.minecraft.skeleton_horse_spawn_egg": "framkallingaregg fyri beinross",
  "item.minecraft.slime_spawn_egg": "framkallingaregg fyri slím",
  "item.minecraft.spider_spawn_egg": "framkallingaregg fyri eiturkopp",
  "item.minecraft.squid_spawn_egg": "framkallingaregg fyri høgguslokk",
  "item.minecraft.stray_spawn_egg": "framkallingaregg fyri reikara",
  "item.minecraft.strider_spawn_egg": "framkallingaregg fyri gleivara",
  "item.minecraft.trader_llama_spawn_egg": "framkallingaregg fyri handilsmannalama",
  "item.minecraft.tropical_fish_spawn_egg": "framkallingaregg fyri tropiskan fisk",
  "item.minecraft.turtle_spawn_egg": "framkallingaregg fyri skjaldbøku",
  "item.minecraft.vex_spawn_egg": "framkallingaregg fyri plágara",
  "item.minecraft.villager_spawn_egg": "framkallingaregg fyri bygdarfólk",
  "item.minecraft.vindicator_spawn_egg": "framkallingaregg fyri rættvísisfólk",
  "item.minecraft.wandering_trader_spawn_egg": "framkallingaregg fyri reikandi handilsmann",
  "item.minecraft.witch_spawn_egg": "framkallingaregg fyri gívur",
  "item.minecraft.wither_skeleton_spawn_egg": "framkallingaregg fyri witherbeinagrind",
  "item.minecraft.wolf_spawn_egg": "kveikjuegg fyri úlv",
  "item.minecraft.zoglin_spawn_egg": "framkallingaregg fyri zoglin",
  "item.minecraft.zombie_spawn_egg": "framkallingaregg fyri zombie",
  "item.minecraft.zombie_horse_spawn_egg": "framkallingaregg fyri zombieross",
  "item.minecraft.zombie_villager_spawn_egg": "framkallingaregg fyri zombiebygdarfólk",
  "item.minecraft.zombified_piglin_spawn_egg": "framkallingaregg fyri deydningarpiglin",
  "item.minecraft.experience_bottle": "gandafløska",
  "item.minecraft.fire_charge": "eldløðing",
  "item.minecraft.writable_book": "bók og fjaðurpennur",
  "item.minecraft.written_book": "skrivað bók",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "lutaramma",
  "block.minecraft.flower_pot": "urtapottur",
  "item.minecraft.carrot": "gularót",
  "item.minecraft.potato": "epli",
  "item.minecraft.baked_potato": "bakað epli",
  "item.minecraft.poisonous_potato": "eitrað epli",
  "item.minecraft.map": "tómt kort",
  "item.minecraft.golden_carrot": "gylt gularót",
  "block.minecraft.skeleton_skull": "skøltur",
  "block.minecraft.wither_skeleton_skull": "witherbeinagrindarskøltur",
  "block.minecraft.player_head": "leikarahøvd",
  "block.minecraft.zombie_head": "zombiehøvd",
  "block.minecraft.creeper_head": "creeperhøvd",
  "block.minecraft.dragon_head": "drekahøvd",
  "item.minecraft.carrot_on_a_stick": "gularót á pinni",
  "item.minecraft.warped_fungus_on_a_stick": "tryglusoppur á einum pinni",
  "item.minecraft.nether_star": "netherstjørna",
  "item.minecraft.pumpkin_pie": "graskerjaterta",
  "item.minecraft.firework_rocket": "fýrverksrakett",
  "item.minecraft.firework_star": "fýrverksstjørna",
  "item.minecraft.enchanted_book": "rúnabók",
  "item.minecraft.nether_brick": "nethermúrsteinur",
  "item.minecraft.quartz": "netherkvarts",
  "item.minecraft.tnt_minecart": "námsvognur við tnt",
  "item.minecraft.hopper_minecart": "námsvognur við trakt",
  "item.minecraft.prismarine_shard": "prismarinbrot",
  "item.minecraft.prismarine_crystals": "prismarinkrystallir",
  "item.minecraft.rabbit": "rá kanin",
  "item.minecraft.cooked_rabbit": "kókað kaninkjøt",
  "item.minecraft.rabbit_stew": "kaninstúvningur",
  "item.minecraft.rabbit_foot": "kaninfótur",
  "item.minecraft.rabbit_hide": "kaninskinn",
  "item.minecraft.armor_stand": "brynjuhaldari",
  "item.minecraft.iron_horse_armor": "jarnbrynjan til ross",
  "item.minecraft.golden_horse_armor": "gullbrynja til ross",
  "item.minecraft.diamond_horse_armor": "diamantbrynjan til ross",
  "item.minecraft.leather_horse_armor": "leðurrossabrynja",
  "item.minecraft.lead": "snórur",
  "item.minecraft.name_tag": "navnaskelti",
  "item.minecraft.command_block_minecart": "námsvognur við stýriboðskubba",
  "item.minecraft.mutton": "rátt lambskjøt",
  "item.minecraft.cooked_mutton": "kókað lambskjøt",
  "block.minecraft.white_banner": "hvítt merki",
  "block.minecraft.orange_banner": "appilsingult flagg",
  "block.minecraft.magenta_banner": "viólreytt flagg",
  "block.minecraft.light_blue_banner": "ljósablátt flagg",
  "block.minecraft.yellow_banner": "gult flagg",
  "block.minecraft.lime_banner": "ljósagrønt flagg",
  "block.minecraft.pink_banner": "ljósareytt flagg",
  "block.minecraft.gray_banner": "grátt flagg",
  "block.minecraft.light_gray_banner": "ljósagrátt flagg",
  "block.minecraft.cyan_banner": "blágrønt flagg",
  "block.minecraft.purple_banner": "lilla flagg",
  "block.minecraft.blue_banner": "blátt flagg",
  "block.minecraft.brown_banner": "brúnt flagg",
  "block.minecraft.green_banner": "grønt flagg",
  "block.minecraft.red_banner": "reytt flagg",
  "block.minecraft.black_banner": "svart flagg",
  "item.minecraft.end_crystal": "endkrystall",
  "item.minecraft.chorus_fruit": "chorus-frukt",
  "item.minecraft.popped_chorus_fruit": "opin chorus-frukt",
  "item.minecraft.beetroot": "reyðrót",
  "item.minecraft.beetroot_seeds": "reyðrótarfræ",
  "item.minecraft.beetroot_soup": "reyðrótarsúpan",
  "item.minecraft.dragon_breath": "drekaandi",
  "item.minecraft.splash_potion": "ikki-bryggjandi sproytandi drykkur□ongar effektir",
  "item.minecraft.spectral_arrow": "spektralørvur",
  "item.minecraft.tipped_arrow": "ikki-evnaligur dyppaður ørvur□ongar effektir",
  "item.minecraft.lingering_potion": "ikki-evnandi varandi drykkur□ongar effektir",
  "item.minecraft.shield": "skjøldur",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "grannbátur",
  "item.minecraft.birch_boat": "bjarkarbátur",
  "item.minecraft.jungle_boat": "frumskógarbátur",
  "item.minecraft.acacia_boat": "akasiubátur",
  "item.minecraft.dark_oak_boat": "myrkur eikibátur",
  "item.minecraft.totem_of_undying": "ódeyðleikans totem",
  "item.minecraft.shulker_shell": "shulkerskel",
  "item.minecraft.iron_nugget": "jarnklumpur",
  "item.minecraft.knowledge_book": "kunnleikabók",
  "item.minecraft.debug_stick": "villurfinningarpinnur",
  "item.minecraft.music_disc_13": "fløga□c418 - 13",
  "item.minecraft.music_disc_cat": "fløga□c418 - cat",
  "item.minecraft.music_disc_blocks": "fløga□c418 - blocks",
  "item.minecraft.music_disc_chirp": "fløga□c418 - chirp",
  "item.minecraft.music_disc_far": "fløga□c418 - far",
  "item.minecraft.music_disc_mall": "fløga□c418 - mall",
  "item.minecraft.music_disc_mellohi": "fløga□c418 - mellohi",
  "item.minecraft.music_disc_stal": "fløga□c418 - stal",
  "item.minecraft.music_disc_strad": "fløga□c418 - strad",
  "item.minecraft.music_disc_ward": "ljómfløga□c418 - ward",
  "item.minecraft.music_disc_11": "fløga□c418 - 11",
  "item.minecraft.music_disc_wait": "fløga□c418 - wait",
  "item.minecraft.music_disc_pigstep": "fløga□lena raine - pigstep",
  "item.minecraft.trident": "trítindur□□when in main hand:□+8 álopsskaði□-2.9 álopsferð",
  "item.minecraft.phantom_membrane": "dreygahinna",
  "item.minecraft.nautilus_shell": "skiparaskeljaskel",
  "item.minecraft.heart_of_the_sea": "havsins hjarta",
  "item.minecraft.crossbow": "lásbogi",
  "item.minecraft.suspicious_stew": "ilgrunasamur grýturættur",
  "block.minecraft.loom": "vevur",
  "item.minecraft.flower_banner_pattern": "flaggmynstur□blómumynstur",
  "item.minecraft.creeper_banner_pattern": "flaggmynstur□creepermynstur",
  "item.minecraft.skull_banner_pattern": "flaggmynstur□skøltursmynstur",
  "item.minecraft.mojang_banner_pattern": "flaggmynstur□lutmynstur",
  "item.minecraft.globe_banner_pattern": "flaggmynstur□globus",
  "item.minecraft.piglin_banner_pattern": "flaggmynstur□snúti",
  "block.minecraft.composter": "kompost",
  "block.minecraft.barrel": "tunna",
  "block.minecraft.smoker": "roykjari",
  "block.minecraft.blast_furnace": "háovnur",
  "block.minecraft.cartography_table": "kortteknaraborð",
  "block.minecraft.fletching_table": "pílamakaraborð",
  "block.minecraft.grindstone": "hvørvisteinur",
  "block.minecraft.lectern": "lesipultur",
  "block.minecraft.smithing_table": "smiðjuborð",
  "block.minecraft.stonecutter": "steinskeri",
  "block.minecraft.bell": "klokka",
  "block.minecraft.lantern": "lykt",
  "block.minecraft.soul_lantern": "sálarlanterna",
  "item.minecraft.sweet_berries": "søt ber",
  "block.minecraft.campfire": "legubál",
  "block.minecraft.soul_campfire": "sálarlegubál",
  "block.minecraft.shroomlight": "soppaljós",
  "item.minecraft.honeycomb": "býflugukøka",
  "block.minecraft.bee_nest": "býflugubøli",
  "block.minecraft.beehive": "býflugubøli",
  "item.minecraft.honey_bottle": "hunangsfløska",
  "block.minecraft.honey_block": "hunangskubbi",
  "block.minecraft.honeycomb_block": "býflugukøkukubbi",
  "block.minecraft.lodestone": "leiðarsteinur",
  "block.minecraft.netherite_block": "netherittkubbi",
  "block.minecraft.ancient_debris": "fornar leivdir",
  "block.minecraft.target": "skotskiva",
  "block.minecraft.crying_obsidian": "grátandi ravntinna",
  "block.minecraft.blackstone": "svartsteinur",
  "block.minecraft.blackstone_slab": "svartsteinspláta",
  "block.minecraft.blackstone_stairs": "svartsteinstrappa",
  "block.minecraft.gilded_blackstone": "gyltur svartsteinur",
  "block.minecraft.polished_blackstone": "pussaður svartsteinur",
  "block.minecraft.polished_blackstone_slab": "pussað svartsteinspláta",
  "block.minecraft.polished_blackstone_stairs": "pussað svartsteinstrappa",
  "block.minecraft.chiseled_polished_blackstone": "chiseled polished blackstone",
  "block.minecraft.polished_blackstone_bricks": "pussaðir svartsteinsmúrsteinar",
  "block.minecraft.polished_blackstone_brick_slab": "pussað svartsteinmúrsteinspláta",
  "block.minecraft.polished_blackstone_brick_stairs": "pussað svartsteinmúrsteinstrappa",
  "block.minecraft.cracked_polished_blackstone_bricks": "cracked polished blackstone bricks",
  "block.minecraft.respawn_anchor": "upprísingarakker",
}
export const fo_fo = items; 
